/* eslint-disable @typescript-eslint/no-unused-vars */
import { isClient } from '../../components/utils/envUtils'

let enableBodyScroll = (_: Element) => ({})
let disableBodyScroll = (_: Element) => ({})
let clearAllBodyScrollLocks = () => ({})

if (isClient) {
  // eslint-disable-next-line global-require
  const bodyScrollLock = require('body-scroll-lock')
  enableBodyScroll = bodyScrollLock.enableBodyScroll
  disableBodyScroll = bodyScrollLock.disableBodyScroll
  clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks
}

const useBodyScrollLock = () => {
  return {
    enableBodyScroll,
    disableBodyScroll,
    clearAllBodyScrollLocks,
  }
}

export default useBodyScrollLock
